import DateAdapter from '@src/utils/DateAdapter'
import CreateEvaluacionAnualDto from '../../domain/CreateEvaluacionAnualDto'
import { VUETIFY_DATE_FORMAT } from '@src/const'

class CreateEvaluacionAnualAdapter {
  static toDto({ idPersonalEvaluador, estatus, fecha, reactivos, tipoEvaluacion }) {
    return CreateEvaluacionAnualDto.create({
      fk_idPersonalEvaluador: idPersonalEvaluador,
      fecha: new DateAdapter(fecha, VUETIFY_DATE_FORMAT).toApiSupportedFormat(),
      fk_idCatEstatusEvaluacion: estatus,
      cumplimientoFunciones: reactivos.map((reactivo) => ({
        calificacion: String(reactivo.calificacion),
        fk_idDescripcionCriterio: reactivo.id,
      })),
      fk_idCatTipoEvaluacion: tipoEvaluacion,
    })
  }
}

export default CreateEvaluacionAnualAdapter
